import React from 'react'
import injectSheet from 'react-jss'
import {
  ArrowButton,
  HouseTypeDetailItem,
  NodeCrumbs,
  TitleContainer,
} from '../../'

class HouseTypeDetail extends React.Component {
  constructor() {
    super()
    this.state = {
      activeSlide: 0,
    }

    this.prev = this.prev.bind(this)
    this.next = this.next.bind(this)
  }

  prev() {
    const { layouts } = this.props
    const { activeSlide } = this.state

    this.setState({ activeSlide: ((activeSlide - 1) + layouts.length) % layouts.length })
  }

  next() {
    const { layouts } = this.props
    const { activeSlide } = this.state

    this.setState({ activeSlide: (activeSlide + 1) % layouts.length })
  }

  render() {
    const {
      classes,
      handleClick,
      houseType,
      layouts,
      parentSelection,
    } = this.props

    const { activeSlide } = this.state

    if (!houseType) { return null }

    return (
      <TitleContainer
        title={<NodeCrumbs id={houseType && houseType.id} />}
        subTitle="Wählen Sie den Grundriss anhand Ihrer..."
      >
        <div
          className="appear-element"
          style={{ transitionDelay: '600ms' }}
        >
          {layouts && Array.isArray(layouts) && (layouts.length > 0) && (
            <div className={`${classes.houseItemContainer}`}>
              {layouts.map((layout, index) => (
                <div
                  className={`${classes.houseItem} ${activeSlide === index && 'active'} ${index === 0 && 'first'}`}
                  key={`houseItem-${layout.id}`}
                >
                  <HouseTypeDetailItem
                    activeNode={houseType}
                    compareOption={layouts.length > 1}
                    handleClick={() => handleClick(layout)}
                    index={index}
                    node={layout}
                    selection={parentSelection.selection}
                  />
                </div>
              ))}
            </div>
          )}
        </div>
        {layouts.length > 1 && (
          <React.Fragment>
            <div className={`${classes.arrow} left`}>
              <ArrowButton
                onClick={this.prev}
                direction="left"
              />
            </div>
            <div className={`${classes.arrow} right`}>
              <ArrowButton
                onClick={this.next}
                direction="right"
              />
            </div>
          </React.Fragment>
        )}
      </TitleContainer>
    )
  }
}

const styles = theme => ({
  arrow: {
    position: 'fixed',
    top: '50%',
    '&.left': {
      left: 0,
    },
    '&.right': {
      right: 0,
    },
  },
  houseItemContainer: {
    position: 'relative',
  },
  houseItem: {
    position: 'absolute',
    top: 0,
    left: 0,
    opacity: 0,
    zIndex: -1,
    width: '100%',
    transition: [
      {
        property: 'opacity',
        duration: theme.speed.fast,
        timingFunction: theme.motion.acceleration,
      },
    ],
    '&.active': {
      opacity: 1,
      zIndex: 1,
    },
    '&.first': {
      position: 'initial',
    },
  },
})

export default injectSheet(styles)(HouseTypeDetail)



// WEBPACK FOOTER //
// ./src/modules/houseType/components/houseTypeDetail.jsx